import { CircleMarker, Tooltip } from "react-leaflet";

const r = (m) => Math.max(2.5, Math.min(9, (m - 2) * 1.8));
const when = (t) => new Date(t).toUTCString().slice(5, 22);

// Display only: M3+ quakes of the last 48 h from USGS + EMSC (incl. NCS India). Never scored, never alerts.
export const FeltQuakeLayer = ({ quakes = [] }) =>
  quakes.map((q) => (
    <CircleMarker key={`${q.time}-${q.lat}-${q.lon}`} center={[q.lat, q.lon]} radius={r(q.mag)} interactive
      pathOptions={{ color: "#fde68a", weight: 1, opacity: 0.9, fillColor: "#f59e0b", fillOpacity: q.mag >= 5 ? 0.75 : 0.45 }}
      eventHandlers={{ click: () => q.url && window.open(q.url, "_blank", "noopener") }}>
      <Tooltip direction="top" className="atlas-tip" opacity={1}>
        <b>M{q.mag.toFixed(1)} · {q.place || "earthquake"}</b>
        <br />
        {when(q.time)} UTC · depth {q.depth_km != null ? `${Math.round(q.depth_km)} km` : "—"}
        <br />
        <span className="atlas-tip-muted">{q.source}{q.also?.length ? ` + ${q.also.join(", ")}` : ""} · information only, not scored</span>
      </Tooltip>
    </CircleMarker>
  ));
